<script setup lang="ts">
const props = defineProps<{
  for?: string
  required?: boolean
}>();
</script>

<template>
  <label class="mb-1 block font-bold" :for="props.for"><slot /> <span v-if="props.required" class="text-red-500 font-bold">*</span></label>
</template>

<style scoped>

</style>
